import { useState } from "react";

import { Image } from "@components/Image";

import { useUnblockUserByIdMutation } from "@storage/queries/blacklist";
import { useUnmuteUserByIdMutation } from "@storage/queries/chat/mute";

import { ICON_PATHS } from "@configs/icons";

interface ChatBlockPanelProps {
	userId: string;
	isMuted: boolean;
}

export const ChatBlockPanel = ({ userId, isMuted }: ChatBlockPanelProps) => {
	const [isLoading, setIsLoading] = useState(false);

	const unBlockUserByIdMutation = useUnblockUserByIdMutation();
	const unmuteUserByIdMutation = useUnmuteUserByIdMutation();

	const handleClick = () => {
		setIsLoading(true);
		if (isMuted) {
			unmuteUserByIdMutation.mutate({ userId });
			setIsLoading(false);
		} else {
			unBlockUserByIdMutation.mutate({ userId });
			setIsLoading(false);
		}
	};

	return (
		<div className="mx-4 mb-5 flex h-19 shrink-0 items-center justify-between self-stretch rounded-2xl bg-secondary p-5">
			<div className="flex items-center gap-4">
				<Image width={24} height={24} src={ICON_PATHS.DISABLED} alt="disabled" />

				<span className="mr-2 max-w-[60%] font-[Inter] text-sm leading-normal font-bold text-white">
					{isMuted ? "You’ve muted this user" : "You’ve blocked this user"}
				</span>
			</div>

			<button
				disabled={isLoading}
				className={`flex min-h-10.25 min-w-23.25 cursor-pointer items-center justify-center gap-2 rounded-lg border-none
					bg-primary px-3 py-2 text-center font-[Inter] text-sm leading-normal font-bold text-white outline-none`}
				onClick={handleClick}
			>
				{isMuted ? "Unmute" : "Unban"}
			</button>
		</div>
	);
};
